global.api_url = 'http://api.trackyo.in'
global.odometer_image_url = 'http://3.108.79.43:8003/storage/'
global.documents_image_url='http://3.108.79.43:8008/storage/'